import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(2),
    height: "100%"
  },
  imageWrapper: {
    "&> svg": {
      height: "4em"
    }
  },
  section1: {
    padding: theme.spacing(2)
  },
  section2: {
    padding: theme.spacing(2)
  },
  section3: {},
  section4: {
    padding: theme.spacing(3),
    marginTop: theme.spacing(2)
  },
  sections: {
    marginBottom: theme.spacing(2)
  },
  cardImage: {
    fill: "#4a4f5a",
    stroke: "#4a4f5a",
    strokeWidth: "2",
    [theme.breakpoints.up("md")]: {
      height: "5em"
    },
    [theme.breakpoints.between("sm", "md")]: {
      height: "8em"
    },
    [theme.breakpoints.down("sm")]: {
      height: "3em"
    },
    "@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (-webkit-min-device-pixel-ratio: 1)": {
      height: "6em"
    }
  },
  moreButton: {
    padding: "1em 2em"
  }
}));
